'use strict';

import React from 'react';
import ReactDOM from 'react-dom';
import Cookies from "universal-cookie";

import {CartPopup} from './cart-popup';
import {cart} from "./cart";
export {CartTop};

class CartTop extends React.Component {
    constructor(props) {
        super(props);

        this.state = { cart: this.props.cart, modalIsOpen: this.props.showPopup };

        this.openModal = this.openModal.bind(this);
        this.setIsOpen = this.setIsOpen.bind(this);
        this.closeModal = this.closeModal.bind(this);

        this.onUpdate = this.onUpdate.bind(this);

    }

    setIsOpen(value){
        this.setState({modalIsOpen: value});
    }

    openModal() {
        this.setIsOpen(true);
    }
    closeModal() {
        this.setIsOpen(false);
    }

    onUpdate(json) {
        this.setState({cart: json.data});
    }


    updateState(result){
        console.log(result);
        this.setState({cart: result.data});
        //this.setState({compatible: result.data.compatible});
    }

    render() {
        if(!this.state.cart){
            cart.getSummary((function(result){
                this.setState({cart: result.data});
            }).bind(this));
        }
        if(typeof this.state.cart.items != 'undefined' && this.state.cart.items.length > 0){
            this.state.cart.items.forEach((elem) => {
                if(typeof elem.additional_services != 'undefined' && elem.additional_services.length > 0){
                    elem.additional_services.forEach((service) => {
                        $('.card-block__extra-slider [data-id_product="'+service.product_id+'"] .hardevel_service_add').trigger('click');
                    });
                }
            });
        }

        return (
            <React.Fragment>
                <If condition={typeof this.state.cart.items != 'undefined' && this.state.cart.items.length > 0}>
                    <If condition={isMobile}>
                        <button className="hmn-link--bag" onClick={orderLink != window.location.href ? this.openModal : null}>{lajax.t('Корзина')} <span className="num">{this.state.cart.total_count}</span></button>
                    </If>
                    <If condition={!isMobile}>
                        <button className="header-basket" onClick={orderLink != window.location.href ? this.openModal : null}>
                            <span className="header-basket__icon">
                                <span className="header-basket__quan">{this.state.cart.total_count}</span>
                            </span>
                            <span className="header-basket__column">
                                <span className="header-basket__text">{lajax.t('Сумма')}</span>
                                <span className="header-basket__summ">{tools.displayPrice(this.state.cart.total_price)} ₴</span>
                            </span>
                        </button>
                    </If>
                    <If condition={orderLink != window.location.href}>
                        <CartPopup
                            title={lajax.t('Корзина')}
                            modalIsOpen={this.state.modalIsOpen}
                            closeModal={this.closeModal}
                            cart={this.state.cart}
                            onUpdate={this.onUpdate}
                            showTotal={this.props.showTotal}
                            list="Корзина в шапке"
                        />
                    </If>
                </If>
                <If condition={typeof this.state.cart.items == 'undefined' || this.state.cart.items.length == 0}>
                    <If condition={isMobile}>
                        <button className="hmn-link--bag">{lajax.t('Корзина')}</button>
                    </If>
                    <If condition={!isMobile}>
                        <button className="header-basket">
                            <span className="header-basket__icon">
                            </span>
                        </button>
                    </If>
                </If>

            </React.Fragment>
        );
    }
}

const e = React.createElement;

export function cartTopShow(cartData, showCartPopup)
{
    let domContainer = document.querySelector('.header-center .header-basket-container');
    if(isMobile){
        domContainer = document.querySelector('.header-mobile-navbar .header-basket-container');
    }
    try{
        ReactDOM.unmountComponentAtNode(domContainer);
    }catch(e){

    }
    domContainer = document.querySelector('.header-center .header-basket-container');
    if(isMobile){
        domContainer = document.querySelector('.header-mobile-navbar .header-basket-container');

    }

    if(domContainer){
        ReactDOM.render(e(CartTop, {
            cart: cartData,
            showPopup: showCartPopup,
            showTotal: true,

            //categoriesFilter: categoriesFilter,
            //categoriesFeature: categoriesFeature,
        }), domContainer);
    }
}

$(function(){
    if(!window.cartTopOnce){
        cartTopShow(typeof(cartData) != 'undefined' ? cartData : false, false);
        window.cartTopOnce = true;
    }

})


